import { render, staticRenderFns } from "./equity.vue?vue&type=template&id=8b10fc0a&scoped=true&"
import script from "./equity.vue?vue&type=script&lang=js&"
export * from "./equity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b10fc0a",
  null
  
)

export default component.exports